module.exports = __webpack_public_path__ + "static/media/ABNB_Report_IPOIntelligence_g.2db43c67.png";